import { AppDispatch, RootState } from "./store";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

/** Typed `useDispatch` hook. */
export const useAppDispatch = () => useDispatch<AppDispatch>();

/** Typed `useSelector` hook. */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
